import * as THREE from 'three';
import PolyMap from '../model/PolyMap';
import applyFunctionToPolyMap from './applyFunctionToPolyMap';

export default function sortFacesByAxis(polyMesh, axis, withLogging) {

  function reorderFacesOnPolymap(polyMap, polyMapName, additionalArguments) {
    const newFaceRangeOffsets = additionalArguments.newFaceRangeOffsets;
    const reMapping = additionalArguments.reMapping;

    const faceRangeOffsets = polyMap.faceRangeOffsets;
    const faceValueIndices = polyMap.faceValueIndices;
    const newFaceValueIndices = new Uint32Array(faceValueIndices.length);
    let newFaceValueIndicesMarker = 0;

    for (let i = 0; i < reMapping.length; i++) {
      for (let j = faceRangeOffsets[reMapping[i]]; j < faceRangeOffsets[reMapping[i] + 1]; j++) {
        newFaceValueIndices[newFaceValueIndicesMarker++] = faceValueIndices[j];
      }
    }

    const newPolyMap = new PolyMap({
      faceRangeOffsets: newFaceRangeOffsets,
      faceValueIndices: newFaceValueIndices,
      values: polyMap.values,
    });

    return newPolyMap;

  };

  const l = withLogging || false;
  if (!axis || !polyMesh) return polyMesh;
  if (axis.x === 0 && axis.y === 0 && axis.z === 0) return polyMesh;

  const faceRangeOffsets = polyMesh.faceRangeOffsets;
  const newFaceRangeOffsets = new Uint32Array(polyMesh.faceRangeOffsets.length);
  const faceValueIndices = new Uint32Array(polyMesh.positions.faceValueIndices);
  const values = polyMesh.positions.values;

  //create a mapping for the faces (0, 1, 2, 3, 4...)
  const faces = [];
  const faceDistances = [];

  const centroid = new THREE.Vector3();
  const tempValue = new THREE.Vector3();

  for (let i = 0; i < faceRangeOffsets.length - 1; i++) {
    faces[i] = i;

    const faceStart = faceRangeOffsets[i];
    const faceEnd = faceRangeOffsets[i + 1];

    centroid.set(0, 0, 0);
    for (let j = faceStart; j < faceEnd; j++) {
      values.getAt(faceValueIndices[j], tempValue);
      centroid.add(tempValue);
    }

    centroid.multiplyScalar(1 / (faceEnd - faceStart));

    //projection of v1 and v2 on camera axis compare magnitudes
    faceDistances[i] = centroid.dot(axis);
  }

  //sort the face mapping by the values of their indices
  faces.sort(function (a, b) { return faceDistances[b] - faceDistances[a]; });

  for (let i = 0; i < faces.length; i++) {
    newFaceRangeOffsets[i + 1] = newFaceRangeOffsets[i] + (faceRangeOffsets[faces[i] + 1] - faceRangeOffsets[faces[i]]);
  }

  if (l) {//print out all the faces to compare old and new
    console.log('Face List [old][new]:');
    for (let i = 0; i < faces.length; i++) {
      let face = [];
      let newFace = [];
      for (let j = faceRangeOffsets[i]; j < faceRangeOffsets[i + 1]; j++) {
        face.push(faceValueIndices[j]);
      }

      for (let j = faceRangeOffsets[faces[i]]; j < faceRangeOffsets[faces[i] + 1]; j++) {
        newFace.push(faceValueIndices[j]);
      }

      console.log(face, newFace);
    }
  }

  const args = { newFaceRangeOffsets: newFaceRangeOffsets, reMapping: faces };
  return applyFunctionToPolyMap(polyMesh, reorderFacesOnPolymap, args).topologyChanged();
};



// WEBPACK FOOTER //
// ./src/polyMesh/geometric/operator/sortFacesByAxis.js